import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import CustomDropdown from "./dashboard-select";
import { DropDownListContainer } from '../styles/dashboard';
import orderBy from "lodash/orderBy";
import Chart from "./player-chart";
import { TEAM_COLORS, colorForTeamId } from "api/Teams";
import { Loader } from "react-loaders";

const TeamDynamicsPopup = styled(Modal)`
  background: rgba(0, 0, 0, 0.8) !important;

  .modal-dialog {
    width: 1077px !important;

    .modal-content {
      padding: 0 !important;
      border-radius: 4px !important;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
      border: none !important;
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0 !important;
  height: 737px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 48px 0 0 42px;
`;

const HeaderTitle = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #bdbdbd;
`;

const TeamNameDropdown = styled.div`
  margin-left: 15px;
`;

const StudentsNameDropdown = styled.div`
  margin-left: 15px;
`;

const AbsoluteListContainer = styled(DropDownListContainer)`
  position: absolute;
`;

const UsersList = styled.div`
  width: 236px;
`;

const Teamname = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 55px;
  color: #4f4f4f;
  text-transform: uppercase;
  text-align: center;
  margin-top: 38px;
  margin-bottom: 28px;
`;

const Username = styled.div`
  width: 236px;
  height: 33px;
  border-radius: 0 10px 10px 0;
  font-family: Lato;
  font-weight: bold;
  font-size: 18px;
  line-height: 33px;
  color: #000000;
  padding: 0 0 0 60px;
  margin: 4px 0;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  &:hover {
    cursor: pointer;
  }

  ${p =>
    p.isActive &&
    `
    background: rgba(141, 217, 222, 0.28);
  `}
`;

const Body = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 60px;
`;

const Line = styled.div`
  width: 3px;
  height: 400px;
  background: rgba(224, 224, 224, 0.25);
  margin: 85px 40px 0 20px;
`;

const ChartTitle = styled.div`
  font-family: Lato;
  font-weight: 800;
  font-size: 24px;
  line-height: 38px;
  color: #52c5cd;
  text-transform: uppercase;
  text-align: center;
`;

const ChartDescription = styled.div`
  font-family: Lato;
  font-weight: bold;
  font-size: 24px;
  line-height: 55px;
  color: #2a4169;
  text-align: center;
`;

const ChartWrapper = styled.div`
  width: 778px;

  ${p => p.hiddenSidebar && `
    margin-left: auto;
    margin-right: auto;
  `}
`;

const ChartContent = styled.div`
  text-align: center;
  padding-right: 50px;
`;

const Placeholder = styled.div`
  font-family: Lato;
  font-size: 40px;
  line-height: 48px;
  color: #bdbdbd;
  padding: 0 40px 0 0;
  width: 563px;
  text-align: center;
  margin: 184px auto 0;
`;

const StyledLoader = styled.div`
  width: 100%;
  padding-right: 40px;

  .loader {
    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 184px;
        border-color: #2a4169;
      }
    }
  }
`;

const getTeamsList = teams =>
  orderBy(teams, ["name"], ["asc"]).map(team => ({
    id: team.id,
    name: `Team ${team.name}`
  }));

const getTeamName = (currentTeam, teams) => {
  const team = teams.find(i => i.id === currentTeam);

  return team ? `Team ${team.name}` : "";
};

const getPlayersList = (players, callback = player => player.username) =>
  orderBy(players, ["username"], ["asc"]).reduce(
    (state, player) => ({
      ...state,
      [player.id]: callback(player)
    }),
    {}
  );

const isUserSelected = (currentTeam, currentPlayer, surveys) =>
  currentTeam > 0 && currentPlayer > 0 && surveys.length > 0;

const getPlayerName = (currentPlayer, players) => {
  const player = players.find(i => i.id === currentPlayer);

  return player ? `${player.first_name} ${player.last_name}` : "";
};

const getScoreTitle = (reports, surveys, currentSurvey) => {
  const survey = surveys.find(i => i.id === currentSurvey);

  if (!survey) {
    return "Did Not Work Well With Team";
  }

  if (!(survey.stage in reports)) {
    return "Did Not Work Well With Team";
  }

  const report = reports[survey.stage];

  if (report.collaboration && report.collaboration.most_valuable === "Yes") {
    return "Most Valuable Team Member";
  }

  if (report.collaboration && report.collaboration.work_again_percentage >= 66) {
    return "Worked Very Well With Team";
  }

  if (
    report.collaboration &&
    report.collaboration.work_again_percentage >= 50 &&
    report.collaboration.work_again_percentage < 66
  ) {
    return "Worked Well Together";
  }

  return "Did Not Work Well With Team";
};

const Charts = {};

Charts.Teams = {};

Charts.Teams.Wrapper = styled.div`
  display: flex;
  padding-top: 30px;
  padding-bottom: 20px;
  color: #36507e;
  font-weight: 600;
  font-size: 15px;
`;

Charts.Teams.Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${p =>
    p.margin &&
    `
    margin: ${p.margin};
  `}
`;

Charts.Teams.TeamColor = styled.div`
  height: 10px;
  width: 40px;
  margin-right: 10px;

  ${p =>
    p.background &&
    `
    background: ${p.background};
  `}
`;

Charts.Teams.TeamName = styled.div`
  font-size: 14px;
  color: #36507e;
`;

const getTeamColor = (teams, currentTeam) =>
  colorForTeamId(teams, currentTeam, TEAM_COLORS) || TEAM_COLORS[0];

const TeamDynamicsPopupComponent = ({
  show,
  onHide,
  teams,
  title,
  currentTeam,
  selectTeam,
  players,
  currentPlayer,
  selectPlayer,
  setPlayerValueCallback,
  setPlayerValue,
  reports,
  userScoreReports,
  surveys,
  allTeams,
  isSurveyFinished,
  currentSurvey,
  isReportsLoading,
  isPlayersLoading,
  hideDropdowns,
}) => (
  <TeamDynamicsPopup
    show={show}
    onHide={onHide}
    backdropClassName="transparent-backdrop"
  >
    <ModalBody>
      <Header>
        <HeaderTitle>{title}</HeaderTitle>
        {!hideDropdowns &&
          <TeamNameDropdown>
            <CustomDropdown
              options={getTeamsList(teams)}
              placeholder="Team Name"
              onChange={selectTeam}
              DropDownListContainer={AbsoluteListContainer}
              customId="id"
              customName="name"
            />
          </TeamNameDropdown>}
        {!hideDropdowns &&
          <StudentsNameDropdown>
            <CustomDropdown
              options={getPlayersList(players)}
              placeholder="Students Name"
              onChange={selectPlayer}
              DropDownListContainer={AbsoluteListContainer}
              setValueCallback={setPlayerValueCallback}
            />
          </StudentsNameDropdown>}
      </Header>
      <Body>
        {!hideDropdowns &&
          <UsersList>
            {currentTeam > 0 && (
              <Teamname>{getTeamName(currentTeam, teams)}</Teamname>
            )}
            {currentTeam > 0 &&
              Object.entries(
                getPlayersList(
                  players,
                  player => `${player.first_name} ${player.last_name}`
                )
              )
                .map(([id, username]) => ({ id: parseInt(id, 10), username }))
                .map(player => (
                  <Username
                    key={player.id}
                    isActive={player.id === currentPlayer ? true : false}
                    onClick={() => setPlayerValue(player.id)}
                    title={player.username}
                  >
                    {player.username}
                  </Username>
                ))}
          </UsersList>}
        {!hideDropdowns &&
          <Line />}
        {isUserSelected(currentTeam, currentPlayer, surveys) === true &&
          Object.keys(reports).length > 0 &&
          !isReportsLoading &&
          !isPlayersLoading && (
            <ChartWrapper hiddenSidebar={hideDropdowns}>
              <ChartTitle>
                {getScoreTitle(reports, surveys, currentSurvey)}
              </ChartTitle>
              <ChartDescription>
                {getPlayerName(currentPlayer, players)}
              </ChartDescription>
              <Charts.Teams.Wrapper>
                <Charts.Teams.Row>
                  <Charts.Teams.TeamColor
                    background={getTeamColor(allTeams, currentTeam)}
                  />
                  <Charts.Teams.TeamName>You</Charts.Teams.TeamName>
                </Charts.Teams.Row>
                <Charts.Teams.Row margin="0 20px">
                  <Charts.Teams.TeamColor background="#eee" />
                  <Charts.Teams.TeamName>Team Average</Charts.Teams.TeamName>
                </Charts.Teams.Row>
                <Charts.Teams.Row margin="0 20px">
                  <Charts.Teams.TeamColor background="#c4c4c4" />
                  <Charts.Teams.TeamName>Team Median</Charts.Teams.TeamName>
                </Charts.Teams.Row>
              </Charts.Teams.Wrapper>
              <ChartContent>
                <Chart
                  reports={reports}
                  userScoreReports={userScoreReports}
                  surveys={surveys}
                  userId={currentPlayer}
                  players={players}
                  currentTeam={currentTeam}
                  teams={allTeams}
                  isSurveyFinished={isSurveyFinished}
                />
              </ChartContent>
            </ChartWrapper>
          )}
        {isUserSelected(currentTeam, currentPlayer, surveys) === true &&
          Object.keys(reports).length === 0 &&
          !isReportsLoading &&
          !isPlayersLoading && (
            <ChartWrapper hiddenSidebar={hideDropdowns}>
              <Placeholder>User results not found</Placeholder>
            </ChartWrapper>
          )}
        {isUserSelected(currentTeam, currentPlayer, surveys) === false &&
          !isReportsLoading &&
          !isPlayersLoading && (
            <ChartWrapper hiddenSidebar={hideDropdowns}>
              <Placeholder>Select a Team or Student</Placeholder>
            </ChartWrapper>
          )}
        {(isReportsLoading || isPlayersLoading) && (
          <StyledLoader>
            <Loader type="ball-scale-ripple" active />
          </StyledLoader>
        )}
      </Body>
    </ModalBody>
  </TeamDynamicsPopup>
);

export default TeamDynamicsPopupComponent;



// WEBPACK FOOTER //
// ./src/instructor/components/team-dynamics-popup.js